import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import VerifyOtp from '../pages/customers/guest/VerifyOtp'

const OtpVerifyRoutes = () => {
  const { txtconnect_ng_user, isVerified } = useSelector((state) => state.user);

  //* If user is verified, redirect to home
  if (txtconnect_ng_user && isVerified) {
    return <Navigate to="/home" replace />;
  }

  //* If user is not authenticated at all, redirect to login
  if (!txtconnect_ng_user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Routes>
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="*" element={<VerifyOtp />} />
    </Routes>
  )
}

export default OtpVerifyRoutes